import { useQuery } from '@tanstack/react-query';
import authAxios from '@services/authAxios';
import { buildQueryString } from '../../utils';

const baseUrl = '/api/v1/parahub-store-config';

export const useGetStoreConfigList = (filters) => {
    return useQuery({
        queryKey: ['store-config-list', filters],
        queryFn: async () => {
            const queryString = buildQueryString(filters);
            const { data } = await authAxios.get(`${baseUrl}?${queryString}`);
            return data;
        },
        select: (data) => {
            const page_data = data.data.page_data.map((item) => ({
                ...item,
                id: item.customer_id,
            }));

            const res = {
                ...data,
                data: {
                    ...data.data,
                    page_data,
                },
            };

            return res;
        },
        refetchOnWindowFocus: false,
        retry: false,
        gcTime: 0,
    });
};

export const useGetStoreConfigDetail = (id) => {
    return useQuery({
        queryKey: ['store-config-detail', id],
        queryFn: async () => {
            const { data } = await authAxios.get(`${baseUrl}/${id}`);
            return data?.data;
        },
        refetchOnWindowFocus: false,
        retry: false,
        gcTime: 0,
    });
};
